import React from 'react';
import { ErrorMessage } from './ErrorMessage';
import { MessageIfEmpty } from './MessageIfEmpty';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorIfEmpty = ({
  children,
  isLoading = false
}) => /*#__PURE__*/_jsx(MessageIfEmpty, {
  messageComponent: /*#__PURE__*/_jsx(ErrorMessage, {}),
  isLoading: isLoading,
  children: children
});